import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import Shell from '../components/shell/shell';
import { HomePage } from './home-page';

export const Pages: FC = () => {
  return (
    <Shell>
      <Routes>
        <Route index element={<HomePage />} />
      </Routes>
    </Shell>
  );
};

export default Pages;
